module.exports = __webpack_public_path__ + "static/media/flooring-section.a7ffb327.webp";